module.exports = __webpack_public_path__ + "static/media/PB040493.3571d38c.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/comic-con/PB040493.JPG
// module id = 192
// module chunks = 0